function mobileNav() {
    if (window.innerWidth <= 991) {
      const menuItems = document.querySelectorAll('#main-menu > li.nav-item.dropdown > a');
      menuItems.forEach((item) => {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          this.parentNode.classList.toggle('active');
          let siblings = Array.from(this.parentNode.parentNode.children);
            siblings.splice(siblings.indexOf(this.parentNode), 1); // remove clicked item from sibling list
            siblings.forEach((sibling) => {
              sibling.classList.remove('active');
              sibling.classList.toggle('not-active');
            });
        });
      });
    }
  
    if (window.innerWidth <= 991) {
      const navbarToggler = document.querySelector('.navbar-toggler');
      const mainMenu = document.querySelector('#main-menu');
  
      navbarToggler.addEventListener('click', function() {
        const menuItems = Array.from(mainMenu.children);
  
        // Remove 'active' and 'not-active' classes from each menu item
        menuItems.forEach((item) => {
          item.classList.remove('active', 'not-active');
        });
      });
    } else {
      const mainMenu = document.querySelector('#main-menu');
      const menuItems = Array.from(mainMenu.children);
      menuItems.forEach((item) => {
        item.classList.remove('active', 'not-active');
      });
    }
  }
  
  window.addEventListener('resize', mobileNav);
  
  mobileNav();